import { render, staticRenderFns } from "./AddNewTagModal.vue?vue&type=template&id=5e3d9a1c&"
import script from "./AddNewTagModal.vue?vue&type=script&lang=js&"
export * from "./AddNewTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports